import * as React from 'react';
import { useSelector } from 'react-redux';

import { ReactComponent as BadgePercentIcon } from '../../svg/badge-percent.svg';
import { TabScreens } from '../../../routes';
import { RootState } from '../../../store';

export const SearchTabSvg: React.FC = () => {
  const currentTabScreen = useSelector(
    (state: RootState) => state.tabSlice.screen,
  );

  const fillColor =
    currentTabScreen === TabScreens.Menu
      ? 'var(--main-turquoise)'
      : 'var(--text-color)';

  return (
    // <BadgePercentIcon
    //   width={48}
    //   height={48}
    //   stroke={fillColor}
    //   fill="none"
    // />
    <svg xmlns="http://www.w3.org/2000/svg" strokeWidth={1.5} id="Layer_1" data-name="Layer 1" viewBox="0 0 28 28" width="26" height="26" stroke="var(--text-color)" fill="none"><path d="M24,12c0-1.617-.708-3.136-1.92-4.175,.122-1.591-.451-3.166-1.595-4.31-1.143-1.144-2.723-1.717-4.31-1.595-1.04-1.212-2.559-1.92-4.176-1.92s-3.136,.708-4.176,1.92c-1.587-.122-3.166,.451-4.31,1.595-1.144,1.145-1.717,2.719-1.595,4.31-1.212,1.039-1.92,2.558-1.92,4.175s.708,3.136,1.92,4.175c-.122,1.591,.451,3.166,1.595,4.31,1.144,1.143,2.723,1.714,4.31,1.595,1.04,1.212,2.559,1.92,4.176,1.92s3.136-.708,4.176-1.92c1.588,.121,3.167-.452,4.31-1.595,1.144-1.145,1.717-2.719,1.595-4.31,1.212-1.039,1.92-2.558,1.92-4.175Zm-3.546,2.904l-.55,.37,.127,.65c.223,1.145-.136,2.322-.96,3.146-.824,.824-1.999,1.183-3.147,.96l-.649-.126-.37,.549c-.653,.968-1.739,1.546-2.904,1.546s-2.251-.578-2.904-1.546l-.37-.549-.649,.126c-1.149,.222-2.323-.137-3.147-.96-.824-.825-1.183-2.001-.96-3.146l.127-.65-.55-.37c-.968-.653-1.546-1.739-1.546-2.904s.578-2.251,1.546-2.904l.55-.37-.127-.65c-.223-1.145,.136-2.322,.96-3.146,.824-.824,2-1.18,3.147-.96l.649,.126,.37-.549c.653-.968,1.739-1.546,2.904-1.546s2.251,.578,2.904,1.546l.37,.549,.649-.126c1.147-.222,2.323,.136,3.147,.96,.824,.825,1.183,2.001,.96,3.146l-.127,.65,.55,.37c.968,.653,1.546,1.739,1.546,2.904s-.578,2.251-1.546,2.904Zm-11.454-4.904c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Zm7,5c0,.552-.448,1-1,1s-1-.448-1-1,.448-1,1-1,1,.448,1,1Zm-.434-7l-4.8,8h-2.332l4.8-8h2.332Z"></path></svg>
  );
};
